import { Entity } from '@core/entities/entity'
import { ISuggestedApprover } from '@core/entities/permit/SuggestedApprover/ISuggestedApprover'

export class SuggestedApprover extends Entity<ISuggestedApprover> {
  id: number
  name: string
  company: string
  companyId?: number
}
